"use strict";
(function (Drupal, once) {
    Drupal.behaviors.mobileExpandedMenu = {
        attach: function (context) {
            once('mobileExpandedMenu', '#js-open-mobile-expanded-menu', context).forEach(function (element) {
                element.addEventListener('click', function (event) {
                    const mobileExpandedMenu = document.querySelector('.js-mobile-expanded-menu');
                    // Toggle call to action button
                    const toggleCallToAction = document.querySelector('.js-toggle-call-to-action');
                    const BODY = document.querySelector('html');
                    if (mobileExpandedMenu) {
                        // Check if the mobile expanded menu is closed
                        if (mobileExpandedMenu === null || mobileExpandedMenu === void 0 ? void 0 : mobileExpandedMenu.classList.contains('hidden')) {
                            // Remove the hidden class from mobile expanded menu
                            mobileExpandedMenu === null || mobileExpandedMenu === void 0 ? void 0 : mobileExpandedMenu.classList.remove('hidden');
                            // Add the overflow hidden class to the body
                            BODY === null || BODY === void 0 ? void 0 : BODY.classList.add('overflow-hidden');
                            // Hide the call to action button
                            if (toggleCallToAction) {
                                toggleCallToAction.classList.add('hidden');
                            }
                        }
                        else {
                            // Add the hidden class to mobile expanded menu
                            mobileExpandedMenu === null || mobileExpandedMenu === void 0 ? void 0 : mobileExpandedMenu.classList.add('hidden');
                            // Remove the overflow hidden class from the body
                            BODY === null || BODY === void 0 ? void 0 : BODY.classList.remove('overflow-hidden');
                            // Show the call to action button
                            if (toggleCallToAction) {
                                toggleCallToAction.classList.remove('hidden');
                            }
                        }
                    }
                });
            });
        },
    };
})(Drupal, once);
